import Vuex from 'vuex';
import mutations from '@/_legacy/store/mutations';
import getters from '@/_legacy/store/getters';
import state from '@/_legacy/store/state';
import conduct, { setStoreInstance } from '@/_legacy/store/conduct';
import checklist_builder from '@/_legacy/store/checklist_builder';
import subscription from '@/_legacy/store/subscription';

const store = new Vuex.Store({
  state,
  mutations,
  getters,
  modules: {
    conduct,
    checklist_builder,
    subscription,
  },
});

// Store the store instance in the conduct module for use in mutations
setStoreInstance(store);

export default store;
